/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1WorkChargesDestroyPathParameters,
  BillingV1WorkChargesListParams,
  BillingV1WorkChargesPaidMarkPathParameters,
  BillingV1WorkChargesPaidUnmarkPathParameters,
  BillingV1WorkChargesPartialUpdatePathParameters,
  BillingV1WorkChargesRetrievePathParameters,
  BillingWorkChargeInvoicePdfRetrievePathParameters,
  CursorPaginatedWorkChargeResponseV1,
  PatchedWorkChargeUpdateRequestV1Request,
  WorkChargeCreateRequestV1Request,
  WorkChargePreviewRequestV1Request,
  WorkChargePreviewResponseV1,
  WorkChargeResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingWorkChargeService {
  private readonly http = inject(HttpClient);
/**
 * Any authenticated caller, auto-scoped by role (M-bill-12): an admin sees every row and may narrow with `?user_id`; a regular user sees only their own charges, and `?user_id` of another user yields an empty page (filter, not lookup). Returns WorkCharge rows, installations and services, ordered by `issued_at` desc by default (`?date_order=asc` reverses). All filters composable: `?user_id`, `?kind` (`installation` or `service`), `?catchment_work`, `?from_date`/`?to_date`, `?paid` (true/false — absent = no filter).
 * @summary List charges for work (role-scoped, cursor-paginated).
 */
 billingV1WorkChargesList<TData = CursorPaginatedWorkChargeResponseV1>(params?: BillingV1WorkChargesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesList<TData = CursorPaginatedWorkChargeResponseV1>(params?: BillingV1WorkChargesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesList<TData = CursorPaginatedWorkChargeResponseV1>(params?: BillingV1WorkChargesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesList<TData = CursorPaginatedWorkChargeResponseV1>(
    params?: BillingV1WorkChargesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/work_charges/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Creates one WorkCharge + N WorkChargeLine rows atomically. `kind` says what it bills: `installation` (the initial installation of the work) or `service` (corrective maintenance, extra-scope support, repair, emergency visits); it is not editable afterwards and names the PDF title and the `doc_ref` prefix (`INS` / `SER`). Each line stores its own NET `subtotal` = `unit_price * quantity` (the sale price) cut by `discount_pct`, rounded to an integer CLP, and its `margin` over `unit_cost`. The charge's `total_net` is the sum of those subtotals cut by `total_discount_pct`, and `iva` + `total` follow from it. Omit `unit_cost` and `unit_price` on a line to copy the BillingItem's `cost_price` and `sale_price`. `catchment_work` is required (every charge bills work on one obra); `issued_at` is the Chilean day of the create, not an input, and `description` is optional. Returns 201 with the persisted charge; its lines are readable at `.../lines/`.
 * @summary Create a charge for work (installation or service) with N lines.
 */
 billingV1WorkChargesCreate<TData = WorkChargeResponseV1>(workChargeCreateRequestV1Request: WorkChargeCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesCreate<TData = WorkChargeResponseV1>(workChargeCreateRequestV1Request: WorkChargeCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesCreate<TData = WorkChargeResponseV1>(workChargeCreateRequestV1Request: WorkChargeCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesCreate<TData = WorkChargeResponseV1>(
    workChargeCreateRequestV1Request: WorkChargeCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/`,
      workChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/`,
      workChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/work_charges/`,
      workChargeCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Returns the WorkCharge without its lines — they live in the `.../lines/` sub-resource (M-bill-4), one row per BillingItem charged. `total_net` is the persisted SUM over those lines (unlike SubscriptionChargeLine, which is informational), cut by `total_discount_pct`; `total_discount` is the CLP that cut took off (M-bill-13): `SUM(line.subtotal) - total_discount == total_net`.
 * @summary Retrieve one charge for work.
 */
 billingV1WorkChargesRetrieve<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesRetrieve<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesRetrieve<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesRetrieve<TData = WorkChargeResponseV1>(
    { identity }: BillingV1WorkChargesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Preserve-on-omit for `catchment_work` + `description` + `invoice_number` + `total_discount_pct`. The kind is not editable. Lines are NOT editable here — the `.../lines/` sub-resource owns them (V-bill-1), and each of its writes recomputes `total_net`, `iva` and `total`. **Post-payment exception** (M-bill-1e load-bearing rule #3): when `paid_at` is set, the endpoint accepts a body with ONLY `invoice_number` (SII folio); any other field → 409 `/problems/work-charge-paid`. Unmark first via `DELETE .../paid_marks/` for other edits.
 * @summary Partial-update a charge for work (pre-payment for most fields).
 */
 billingV1WorkChargesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPartialUpdatePathParameters,
    patchedWorkChargeUpdateRequestV1Request?: PatchedWorkChargeUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPartialUpdatePathParameters,
    patchedWorkChargeUpdateRequestV1Request?: PatchedWorkChargeUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPartialUpdatePathParameters,
    patchedWorkChargeUpdateRequestV1Request?: PatchedWorkChargeUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesPartialUpdate<TData = WorkChargeResponseV1>(
    { identity }: BillingV1WorkChargesPartialUpdatePathParameters,
    patchedWorkChargeUpdateRequestV1Request?: PatchedWorkChargeUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/`,
      patchedWorkChargeUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/`,
      patchedWorkChargeUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/`,
      patchedWorkChargeUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. CASCADE drops the WorkChargeLine rows. Refused with 409 `/problems/work-charge-paid` when the charge is already marked paid.
 * @summary Hard-delete a charge for work (unpaid only).
 */
 billingV1WorkChargesDestroy<TData = void>(pathParams: BillingV1WorkChargesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesDestroy<TData = void>(pathParams: BillingV1WorkChargesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesDestroy<TData = void>(pathParams: BillingV1WorkChargesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesDestroy<TData = void>(
    { identity }: BillingV1WorkChargesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Any authenticated caller, auto-scoped by role (M-bill-12): a regular user only resolves their own charges — someone else's identity answers the same 404 as a nonexistent one. Returns a binary PDF with the charge detail, titled by its kind (installation or service): each line with its item, its note, the unit sale price, the quantity, the discount and the subtotal (the cost and the margin of a line are never printed), plus the charge-level discount when there is one. The PDF is informational, not a SII tax document. IVA and total come from the M-bill-6 snapshot, never recomputed.
 * @summary Download the invoice PDF of a charge for work
 */
 billingWorkChargeInvoicePdfRetrieve(pathParams: BillingWorkChargeInvoicePdfRetrievePathParameters, options?: HttpClientBodyOptions): Observable<Blob>;
 billingWorkChargeInvoicePdfRetrieve(pathParams: BillingWorkChargeInvoicePdfRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 billingWorkChargeInvoicePdfRetrieve(pathParams: BillingWorkChargeInvoicePdfRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  billingWorkChargeInvoicePdfRetrieve(
    { identity }: BillingWorkChargeInvoicePdfRetrievePathParameters, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `/v1/billing/work_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/v1/billing/work_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/v1/billing/work_charges/${identity}/invoice.pdf`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
/**
 * Admin-only. Same shape / semantics as the SubscriptionCharge variant: sets `paid_at=now()` + `paid_by=<caller>`; idempotent on a second POST.
 * @summary Mark a charge for work as paid (idempotent).
 */
 billingV1WorkChargesPaidMark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidMarkPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesPaidMark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidMarkPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesPaidMark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidMarkPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesPaidMark<TData = WorkChargeResponseV1>(
    { identity }: BillingV1WorkChargesPaidMarkPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Resets `paid_at=None` + `paid_by=None`. Idempotent. Required before editing (other than `invoice_number`) or deleting a paid WorkCharge.
 * @summary Unmark a charge for work as paid (idempotent).
 */
 billingV1WorkChargesPaidUnmark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidUnmarkPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesPaidUnmark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidUnmarkPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesPaidUnmark<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargesPaidUnmarkPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesPaidUnmark<TData = WorkChargeResponseV1>(
    { identity }: BillingV1WorkChargesPaidUnmarkPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/paid_marks/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Stateless: computes the amounts the charge WOULD have and persists nothing — no row is created, no `identity` is returned. Exists so the client never reimplements the arithmetic: the chain is three `ROUND_HALF_UP` roundings over `Decimal`, and a float64 reimplementation disagrees by one peso on the values that land on `.5`. Same defaults as the create — omit `unit_cost` and `unit_price` to copy the BillingItem's `cost_price` and `sale_price` — and both come back resolved, with the margin, since the caller cannot know them. `lines[]` is returned in the order it was sent. Validation mirrors the create on everything that feeds the arithmetic and ignores what does not (`user_id`, `kind`, `catchment_work`, `description`): an installation and a service are priced alike. `total_discount` is the CLP the whole-charge discount takes off (M-bill-13): `SUM(line.subtotal) - total_discount == total_net`.
 * @summary Compute what a charge for work would total, without saving it.
 */
 billingV1WorkChargesPreviewsCreate<TData = WorkChargePreviewResponseV1>(workChargePreviewRequestV1Request: WorkChargePreviewRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargesPreviewsCreate<TData = WorkChargePreviewResponseV1>(workChargePreviewRequestV1Request: WorkChargePreviewRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargesPreviewsCreate<TData = WorkChargePreviewResponseV1>(workChargePreviewRequestV1Request: WorkChargePreviewRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargesPreviewsCreate<TData = WorkChargePreviewResponseV1>(
    workChargePreviewRequestV1Request: WorkChargePreviewRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/previews/`,
      workChargePreviewRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/previews/`,
      workChargePreviewRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/work_charges/previews/`,
      workChargePreviewRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1WorkChargesListClientResult = NonNullable<CursorPaginatedWorkChargeResponseV1>
export type BillingV1WorkChargesCreateClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargesRetrieveClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargesPartialUpdateClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargesDestroyClientResult = NonNullable<void>
export type BillingWorkChargeInvoicePdfRetrieveClientResult = NonNullable<Blob>
export type BillingV1WorkChargesPaidMarkClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargesPaidUnmarkClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargesPreviewsCreateClientResult = NonNullable<WorkChargePreviewResponseV1>
